export const WarningOptionLevelEnum = {
  CREATE: 'CREATE',
  FINISH: 'FINISH'
}
